const STORE_NAME_SPACE = 'ecal-uniwidget-v2';

export function getLocalSettings () {
    const storeNameSpace = STORE_NAME_SPACE;
    const infoJson = localStorage.getItem(storeNameSpace);
    const info = {};

    if (!infoJson) {
        const now = new Date().getTime();
        info.updated = now;
        localStorage.setItem(storeNameSpace, JSON.stringify(info));
        return info;
    }

    return JSON.parse(infoJson);
}

export function setLocalSettings (settings) {
    const storeNameSpace = STORE_NAME_SPACE;
    let localSettings = getLocalSettings();
    localSettings = {
        ...localSettings,
        ...settings,
    };
    localSettings.updated = new Date().getTime();
    localStorage.setItem(storeNameSpace, JSON.stringify(localSettings));
}

export function setSessionSettings (settings) {
    const storeNameSpace = STORE_NAME_SPACE;
    let sessionSettings = getSessionSettings();
    sessionSettings = {
        ...sessionSettings,
        ...settings,

    };
    sessionSettings.updated = new Date().getTime();
    sessionStorage.setItem(storeNameSpace, JSON.stringify(sessionSettings));
}


export function getSessionSettings () {
    const storeNameSpace = STORE_NAME_SPACE;
    const settingsJson = sessionStorage.getItem(storeNameSpace);
    const settings = {};
    if (!settingsJson) {
        const now = new Date().getTime();
        settings.updated = now;
        sessionStorage.setItem(storeNameSpace, JSON.stringify(settings));
        return settings;
    }
    return JSON.parse(settingsJson);
}

export function clearLocalSettings () {
    const storeNameSpace = STORE_NAME_SPACE;
    const settings = {
        updated: new Date().getTime(),
    };
    sessionStorage.setItem(storeNameSpace, JSON.stringify(settings));
}